import { Box, makeStyles, Container, Link, Paper, List, ListItem, alpha } from "@material-ui/core";
import React from "react";
import { Link as RouterLink, NavLink, useLocation } from "react-router-dom";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import ExpandMoreOutlinedIcon from "@material-ui/icons/ExpandMoreOutlined";
import useDevice from "src/hooks/use-device";
import logoImg from "src/assets/images/logos/logo_blue_white.png";
import navigationConfig from "src/configs/navigations";
import Sidebar from "./Sidebar";
import WalletButton from "src/components/WalletButton/index";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
    background: theme.palette.background.primary,
    zIndex: theme.zIndex.appBar,
    borderBottom: "1px solid #ffffff24",
  },
  boxContainer: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    alignItems: "center",
    // maxWidth: 1200,
    margin: "auto",
    height: 59,
  },
  navLink: {
    height: 59,
    padding: "8px 12px",
    margin: "0px 8px",
    color: alpha(theme.palette.common.white, 0.65),
    textDecoration: "none",
    display: "inline-flex",
    alignItems: "center",
    fontSize: "1rem",
    cursor: "pointer",
    transition: "color 300ms linear",
    textTransform: "capitalize",
    fontWeight: 500,
    "&:hover": {
      color: theme.palette.common.white,
    },
  },
  activeLink: {
    color: `${theme.palette.primary.main} !important`,
    borderBottom: "2px solid",
    paddingBottom: "6px",
  },
  dropdown: {
    position: "relative",
    "&:hover $dropdownContent": {
      visibility: "visible",
      opacity: 1,
    },
  },
  navWrapper: {
    display: "flex",
    alignItems: "center",
  },
  dropdownContent: {
    position: "absolute",
    top: "100%",
    right: 0,
    minWidth: "100%",
    zIndex: 100,
    visibility: "hidden",
    opacity: 0,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
  dropdownItem: {
    padding: theme.spacing(0.5, 1),
    "& $navLink": {
      height: "auto",
      color: theme.palette.text.primary,
      whiteSpace: "nowrap",
      width: "100%",
      "&:hover": {
        backgroundColor: "transparent",
      },
    },
    "& $activeLink": {
      border: 0,
      color: theme.palette.primary.main,
    },
  },
}));

export default function Header() {
  const classes = useStyles();
  const { headerDisplayFull } = useDevice();
  const location = useLocation();

  function renderNav(navConfig) {
    const renderItem = (item) => {
      const AnchorTag = item.externalLink ? Link : NavLink;

      return (
        <AnchorTag
          key={item.id}
          className={classes.navLink}
          activeClassName={classes.activeLink}
          href={item.externalLink ? item.navLink : undefined}
          target={item.newTab ? "_blank" : undefined}
          to={item.externalLink ? undefined : item.navLink}
        >
          {item.icon}
          {item.title}
          {item.externalLink && <OpenInNewIcon style={{ marginLeft: 4, fontSize: "1rem" }} />}
        </AnchorTag>
      );
    };

    return navConfig.map((item) => {
      return item.children ? (
        <div key={item.id} className={`${classes.navLink} ${classes.dropdown}`}>
          {item.icon}
          <Box px={0.2}></Box>
          <Box lineHeight={1}>{item.title}</Box>
          <ExpandMoreOutlinedIcon fontSize="small" />
          <Paper elevation={0} className={classes.dropdownContent}>
            <List component="ul">
              {item.children.map((cItem) => (
                <ListItem key={cItem.id} button className={classes.dropdownItem}>
                  {renderItem(cItem)}
                </ListItem>
              ))}
            </List>
          </Paper>
        </div>
      ) : (
        renderItem(item)
      );
    });
  }

  return (
    <Box className={classes.root}>
      <Container maxWidth="xl">
        <Box className={classes.boxContainer}>
          <Box className={classes.navWrapper}>
            <Link component={RouterLink} to="/">
              <img src={logoImg} alt="Logo" style={{ height: "36px", verticalAlign: "middle" }} />
            </Link>
            {headerDisplayFull && (
              <Box px={4} height="100%" display="flex">
                {renderNav(navigationConfig)}
              </Box>
            )}
          </Box>
          <Box display={"flex"} alignItems="center">
            {location.pathname.startsWith("/profile") && <WalletButton />}
            {!headerDisplayFull && <Sidebar />}
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
